import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import AdminLayout from './layouts/AdminLayout';
import TeacherLayout from './layouts/TeacherLayout';
import StudentLayout from './layouts/StudentLayout';

import ModernAdminDashboard from './components/ModernAdminDashboard';
import ManageTeachers from './pages/admin/ManageTeachers';
import ManagePrograms from './pages/admin/ManageProgram';
import ManageStudents from './pages/admin/ManageStudents';
import ManageSemesters from './pages/admin/ManageSemester';
import ManageSubjects from './pages/admin/ManageSubjects';
import AttendanceLogs from './pages/admin/AttendenceLogs';
import TeacherDashboard from './pages/teacher/Dashboard';
import StudentDashboard from './pages/student/Dashboard';

import "./App.css"
import GenerateQRSession from './pages/teacher/GenerateQRSession';
import AssignSubjects from './pages/admin/AssignSubjects';
import StudentEnrollments from './pages/admin/EnrollStudents';
import QRScanner from './pages/student/ScanQRCode';
import Redirections from './components/Redirections';
import ModernLogin from './components/ModernLogin';
import SessionAttendance from './pages/teacher/SessionAttendance';

function App() {
  return (
    <>
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            style: {
              background: '#10b981',
            },
          },
          error: {
            style: {
              background: '#ef4444',
            },
          },
        }}
      />
      <Router>
      <Routes>
        <Route path="/login" element={<ModernLogin />} />
        <Route path='/' element={<Redirections />}></Route>
        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<ModernAdminDashboard />} />
          <Route path="students" element={<ManageStudents />} />
          <Route path="teachers" element={<ManageTeachers />} />
          {/* assign-subject enroll-student */}
          <Route path='assign-subject' element={<AssignSubjects />}></Route>
          <Route path='enroll-student' element={<StudentEnrollments />}></Route>
          <Route path="programs" element={<ManagePrograms />}></Route>
          <Route path="semesters" element={<ManageSemesters />}></Route>
          <Route path="subjects" element={<ManageSubjects />}></Route>
          <Route path="attendance" element={<AttendanceLogs />}></Route>
        </Route>

        {/* Teacher Routes */}
        <Route path="/teacher" element={<TeacherLayout />}>
          <Route index element={<TeacherDashboard />} />
          <Route path='attendence' element={<GenerateQRSession />}></Route>
          <Route path='session-attendance' element={<SessionAttendance />}></Route>
          {/* Add more teacher routes */}
        </Route>

        {/* Student Routes */}
        <Route path="/student" element={<StudentLayout />}>
          <Route index element={<StudentDashboard />} />
          <Route path="scan" element={<QRScanner />}></Route>
          {/* Add more student routes */}
        </Route>
      </Routes>
    </Router>
    </>
  );
}

export default App;
